import { ProductTypeName } from "@covertree/agent-portal-graphql";

export const formatProductTypeName = (productType: ProductTypeName) => {
  switch (productType) {
    case ProductTypeName.MhHomeowners:
      return "MH Homeowners";
    case ProductTypeName.MhLandlord:
      return "MH Landlord";
    case ProductTypeName.FullRepair:
      return "Full Repair";
    default:
      return "Unknown";
  }
};
